import { useQuery } from '@tanstack/react-query';
import { useClient } from 'hooks/useClient';
import { config } from 'config';

export const useScreenshotImage = (url: string | null) => {
  const filesClient = useClient(config.FILES_URL);

  const { data: imageSrc, isLoading } = useQuery({
    queryKey: ['SCREENSHOT_IMAGE', url],
    enabled: !!url,
    staleTime: Infinity, // Never consider cached images stale
    gcTime: 1000 * 60 * 30, // Keep in cache for 30 minutes
    queryFn: async () => {
      const blob = await filesClient.getBlob(url!);
      return URL.createObjectURL(blob);
    },
  });

  return { imageSrc: imageSrc ?? null, isLoading };
};
